<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>后台菜单</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- Tabs -->
        <el-tabs v-model="activeName" type="border-card">
          <!-- 筛选条件 start -->
          <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
            <el-form-item>
              <el-button type="primary" @click="clicksearch">查询</el-button>
            </el-form-item>
          </el-form>
          <!-- 筛选条件 end -->
            <!-- 后台菜单 strat -->
            <el-tab-pane name="first" label="后台菜单">
                <el-table :data="allmenu" border stripe row-key="value" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                    <el-table-column width="100px" prop="listorder" label="排序"></el-table-column>
                    <el-table-column width="100px" prop="value" label="ID"></el-table-column>
                    <el-table-column prop="label" label="菜单名称"></el-table-column>
                    <el-table-column prop="path" label="路由" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="status" label="状态"></el-table-column>
                    <el-table-column prop="operation" label="操作" width="200px">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickeditMenu(scope.$index,scope.row)">编辑</el-button>
                        <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="deleteMenu(scope.$index,scope.row)">删除</el-button>
                      </template>
                    </el-table-column>
                </el-table>

                <!-- 编辑菜单弹出框 start -->
                <el-dialog title="编辑菜单" :visible.sync="displayeditMenu" width="30%" :close-on-click-modal="false">
                    <el-form v-model="editmenudata" ref="editmenudataRef" label-width="55px" class="addmenu">
                        <input v-model="editmenudata.menuid" type="hidden"></input>

                        <el-form-item label="上级" class="addAdminForm">
                            <el-cascader v-model="editmenudata.parentid" :options="allmenu" :props="{ multiple: false, checkStrictly: true }" :show-all-levels="false" clearable style="width:100%"></el-cascader>
                        </el-form-item>

                        <el-form-item label="名称" class="addAdminForm">
                            <el-input v-model="editmenudata.authname" placeholder="请输入名称"></el-input>
                        </el-form-item>

                        <el-form-item label="路由" class="addAdminForm">
                            <el-input v-model="editmenudata.path" placeholder="请输入路由"></el-input>
                        </el-form-item>

                        <el-form-item label="图标" class="addAdminForm">
                            <el-input v-model="editmenudata.iconcls" placeholder="请输入图标"></el-input>
                        </el-form-item>

                        <el-form-item label="排序" class="addAdminForm">
                            <el-input v-model="editmenudata.listorder" placeholder="请输入排序"></el-input>
                        </el-form-item>

                        <el-form-item label="状态" class="addAdminForm">
                            <el-radio v-model="editmenudata.status" label="1">显示</el-radio>
                            <el-radio v-model="editmenudata.status" label="0">隐藏</el-radio>
                        </el-form-item>

                        <el-form-item label="类型" class="addAdminForm">
                            <el-radio v-model="editmenudata.menutype" label="1">权限认证</el-radio>
                            <el-radio v-model="editmenudata.menutype" label="0">菜单</el-radio>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="funsavemenu">保存</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>
                <!-- 编辑菜单弹出框 end -->

            </el-tab-pane>
            <!-- 后台菜单 end -->

            <!-- 添加菜单 start -->
            <el-tab-pane name="second" label="添加菜单">
                <el-form :model="addmenudata" ref="addmenudataRef" label-width="55px">
                    <el-form-item label="上级" class="addAdminForm">
                        <el-cascader v-model="addmenudata.parentid" :options="allmenu" :props="{ multiple: false, checkStrictly: true }" :show-all-levels="false" clearable style="width:100%"></el-cascader>
                    </el-form-item>

                    <el-form-item label="名称" class="addAdminForm">
                        <el-input v-model="addmenudata.authname" placeholder="请输入名称"></el-input>
                    </el-form-item>

                    <el-form-item label="路由" class="addAdminForm">
                        <el-input v-model="addmenudata.path" placeholder="请输入路由"></el-input>
                    </el-form-item>

                    <el-form-item label="图标" class="addAdminForm">
                        <el-input v-model="addmenudata.iconcls" placeholder="请输入图标"></el-input>
                    </el-form-item>

                    <el-form-item label="状态" class="addAdminForm">
                        <el-radio v-model="addmenudata.status" label="1">显示</el-radio>
                        <el-radio v-model="addmenudata.status" label="0">隐藏</el-radio>
                    </el-form-item>

                    <el-form-item label="类型" class="addAdminForm">
                        <el-radio v-model="addmenudata.menutype" label="1">权限认证</el-radio>
                        <el-radio v-model="addmenudata.menutype" label="0">菜单</el-radio>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="funaddmenu">添加</el-button>
                        <el-button type="info" @click="clickreturn">返回</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <!-- 添加菜单 end -->
        </el-tabs>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyBackgroundMenu',
  data () {
    return {
      keywords: {
        jigouid: '-1',
        jigouname: ''
      },
      activeName: 'first',
      addSubMenu: false,
      displayeditMenu: false,
      addmenudata: {
        iconcls: 'el-icon-caret-right'
      },
      editmenudata: { menuid: 0, parentid: 0, authname: '', path: '', iconcls: '', listorder: 0, status: 0, menutype: 0 },
      radio: '',
      allmenu: []
    }
  },
  mounted () {
    this.apigetallmenu()
  },
  methods: {
    clicksearch () {
      this.apigetallmenu()
    },
    deleteMenu (index, row) {
      this.$confirm('是否删除此菜单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apideleteonemenu(row.value)
      })
    },
    clickeditMenu (index, row) {
      this.apigetonemenu(row.value)
    },
    funaddmenu () {
      if (!this.addmenudata.authname) {
        this.$alert('请输入名称', '提示')
        return
      }
      if (!this.addmenudata.path) {
        this.$alert('请输入路由', '提示')
        return
      }
      if (!this.addmenudata.iconcls) {
        this.$alert('请输入图标', '提示')
        return
      }
      if (!this.addmenudata.status) {
        this.$alert('请选择状态', '提示')
        return
      }
      if (!this.addmenudata.menutype) {
        this.$alert('请选择类型', '提示')
        return
      }
      this.apiaddmenu()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    funsavemenu () {
      if (!this.editmenudata.authname) {
        this.$alert('请输入名称', '提示')
        return
      }
      if (!this.editmenudata.path) {
        this.$alert('请输入路由', '提示')
        return
      }
      if (!this.editmenudata.iconcls) {
        this.$alert('请输入图标', '提示')
        return
      }
      if (!this.editmenudata.listorder) {
        this.$alert('请输入排序', '提示')
        return
      }
      if (!this.editmenudata.status) {
        this.$alert('请选择状态', '提示')
        return
      }
      if (!this.editmenudata.menutype) {
        this.$alert('请选择类型', '提示')
        return
      }
      this.apieditonemenu()
    },
    apiaddmenu: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var parentid = '0'
      if (!this.addmenudata.parentid) {
        parentid = '0'
      } else {
        if (this.addmenudata.parentid.constructor === Array) {
          parentid = this.addmenudata.parentid[this.addmenudata.parentid.length - 1]
        } else {
          parentid = this.addmenudata.parentid
        }
      }

      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: parentid,
        authname: this.addmenudata.authname,
        path: this.addmenudata.path,
        iconcls: this.addmenudata.iconcls,
        menutype: this.addmenudata.menutype,
        status: this.addmenudata.status
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addmenu, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apigetallmenu()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetallmenu: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getallmenu, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.allmenu = []
            response.data.List.filter((item1, i1) => {
              var list2 = []
              item1.List.filter((item2, i2) => {
                var list3 = []
                item2.List.filter((item3, i3) => {
                  var status3 = '隐藏'
                  if (item3.Status == 1) status3 = '显示'
                  list3.push({ listorder: item3.Listorder, value: item3.Id, label: item1.Authname + '-->' + item2.Authname + '-->' + item3.Authname, path: item3.Path, status: status3, children: '' })
                })
                var status2 = '隐藏'
                if (item2.Status == 1) status2 = '显示'
                if (list3.length == 0) list3 = ''
                list2.push({ listorder: item2.Listorder, value: item2.Id, label: item1.Authname + '-->' + item2.Authname, path: item2.Path, status: status2, children: list3 })
              })
              var status1 = '隐藏'
              if (item1.Status == 1) status1 = '显示'
              if (list2.length == 0) list2 = ''
              that.allmenu.push({ listorder: item1.Listorder, value: item1.Id, label: item1.Authname, path: item1.Path, status: status1, children: list2 })
            })
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetonemenu: function (menuid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        menuid: menuid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getonemenu, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.editmenudata.menuid = response.data.Id
            that.editmenudata.parentid = response.data.Parentid
            that.editmenudata.authname = response.data.Authname
            that.editmenudata.path = response.data.Path
            that.editmenudata.iconcls = response.data.Iconcls
            that.editmenudata.listorder = response.data.Listorder
            that.editmenudata.status = response.data.Status
            that.editmenudata.menutype = response.data.Menutype

            that.displayeditMenu = true
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditonemenu: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var parentid = 0
      if (!this.editmenudata.parentid) {
        parentid = 0
      } else {
        if (this.editmenudata.parentid.constructor === Array) {
          parentid = this.editmenudata.parentid[this.editmenudata.parentid.length - 1]
        } else {
          parentid = this.editmenudata.parentid
        }
      }
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        menuid: this.editmenudata.menuid,
        parentid: parentid,
        authname: this.editmenudata.authname,
        path: this.editmenudata.path,
        iconcls: this.editmenudata.iconcls,
        listorder: this.editmenudata.listorder,
        menutype: this.editmenudata.menutype,
        status: this.editmenudata.status
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editonemenu, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.displayeditMenu = false
            that.apigetallmenu()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apideleteonemenu: function (menuid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        menuid: menuid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Deleteonemenu, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.apigetallmenu()
          }
		  Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-form-item{
    & span{
        display: inline-block;
        color: #999;
        padding-top: 8px;
        line-height: 22px;
        font-size: 12px;
    }
}
.addmenu{
    height: 500px;
    overflow-y: scroll;
}
/*滚动条的宽度*/
.addmenu::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

/*外层轨道。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果*/
.addmenu::-webkit-scrollbar-track {
    width: 6px;
    background-color: rgba(144,147,153,.1);
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius:2em;
    // display: none;
}

/*滚动条的设置*/
.addmenu::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.2);
    background-clip: padding-box;
    min-height: 28px;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius:2em;
}
/*滚动条移上去的背景*/
.addmenu::-webkit-scrollbar-thumb:hover {
    background-color: rgba(144,147,153,.3);
}
.input_num{
   width: 60px;
}
</style>
